import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import { Link } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import withTheme from "@mui/styles/withTheme";
import styled from "styled-components";
import Color from "../../../assets/colors";
import { FontSize } from "../../../assets/font";

// Snackbar Component //
export const SnackbarStyled = styling(Snackbar)((props) => ({
  //
}));

export const SnackBarContainer = styling("div")((props) => ({
  position: "relative",
  padding: "16px",
  backgroundColor: Color.white,
  width: props.$fullWidth === true ? "100%" : "345px",
  borderRadius: "0.5rem",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0px 0px 13px 1px rgba(151, 147, 147, 0.75)",
  "-webkit-box-shadow": "0px 0px 13px 1px rgba(151, 147, 147, 0.75)",
  "-moz-box-shadow": "0px 0px 13px 1px rgba(151, 147, 147, 0.75)",
}));

// continue to use styled component if there is a need for transient props
export const SnackbarAccent = withTheme(styled(Box)`
  && {
    position: absolute;
    width: 0.25rem;
    background-color: ${(props) =>
      props.$severity === "success"
        ? Color.naikGreen
        : props.$severity === "error"
        ? Color.naikError
        : Color.naikGreen};
    height: 100%;
    border-radius: 0.5rem 0 0 0.5rem;
    left: 0;
    top: 0;
  }
`);

export const SeverityContainer = styling("div")((props) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const SnackbarCheckCircleIconStyled = withTheme(styled(CheckCircleIcon)`
  && {
    color: ${Color.naikGreen};
    width: 1rem;
    height: 1rem;
  }
`);

export const SnackbarErrorCircleIconStyled = styling(ErrorIcon)((props) => ({
  color: Color.naikError,
  width: "1rem",
  height: "1rem",
}));

export const SnackbarSeverityText = styling(Typography)((props) => ({
  fontWeight: "700",
  paddingLeft: "0.5rem",
  fontFamily: "Karla",
}));

export const SnackbarIconButtonStyled = styling(IconButton)((props) => ({
  //
}));

export const LinkStyled = styling(Link)((props) => ({
  color: Color.hiredlyPurple,
  textTransform: "capitalize",
  fontSize: FontSize.desktopCaption,
  fontFamily: "Karla",
}));

export const SnackbarMessageText = styling(Typography)((props) => ({
  color: Color.darkGrey,
  marginTop: "0.25rem",
  fontFamily: "Karla",
}));

export const CloseIconStyled = styling(CloseIcon)((props) => ({
  width: "1rem",
  height: "1rem",
}));
